import { useQuery } from '@tanstack/react-query';
import { AuthNonceHeader, type MPoints, ProfileMPoints } from '@/api/spec.ts';
import { environment } from '../../../environment.ts';
import useAppStore from '../../../store/rootStore.ts';
import { getValidNonce } from '../../../store/slices/authSlice.ts';

const EMPTY_MPOINTS: MPoints = { at: {}, total_mpoints: '0', total_rank: 0, d: [] };

const fetchProfileMPoints = async (authNonce: string): Promise<MPoints> => {
  const response = await fetch(`${environment.apiUrl}${ProfileMPoints}`, {
    headers: {
      [AuthNonceHeader]: authNonce,
    },
  });

  if (response.status === 404) {
    return EMPTY_MPOINTS;
  }

  if (!response.ok) {
    throw new Error('Failed to fetch mPoints');
  }

  return response.json();
};

export const useProfileMPoints = () => {
  const isFullyAuthorized = useAppStore((state) => state.isFullyAuthorized());
  const authNonce = useAppStore((state) => getValidNonce(state.authNonce)?.value);
  const rewardsEnabled = useAppStore((state) => state.config?.features?.rewardsEnabled);

  return useQuery<MPoints>({
    queryKey: ['profile-mpoints', authNonce],
    queryFn: () => fetchProfileMPoints(authNonce!),
    enabled: isFullyAuthorized && Boolean(authNonce) && rewardsEnabled,
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
};
